module.exports = __webpack_public_path__ + "img/down02.088fad06.png";